import React from 'react'
import { Box } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'
import { TotalWmoText } from './TotalWmo.css'

const TotalWmo = props => {
  const { data } = props
  const total = data.estTotal ? parseFloat(data.estTotal) : parseFloat(data.total) - parseFloat(data.taxTotal)

  return (
    <Box>
      <Box direction="row" justify="between">
        <TotalWmoText>
          Total:
        </TotalWmoText>
        <TotalWmoText data-testid='cart-summary-total'>
          $
          {commaSeparetedValue(total)}
        </TotalWmoText>
      </Box>
    </Box>
  )
}

export default TotalWmo
